import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { generalConsultDetailConstants } from './detail.constants';

@Component({
  selector: 'ms-consult-filiation-data',
  templateUrl: './filiation-data.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: GeneralConsultFiliationDataComponent,
      multi: true,
    },
  ],
})
export class GeneralConsultFiliationDataComponent extends BaseValueAccessor<string> {
  readonly screen = generalConsultDetailConstants.filiationData;
  @Input() turn = -1;
  expandSection = true;
}
